import { Button, Flex, Text } from '@revenuemarket/cds';
import { ModalProps } from 'antd';
import { useRouter } from 'next/router';
import {
  PermissionRequirement,
  AssetPermissionRequirement,
} from '~components/Role/PermissionGuard';
import { useAvailablePermissions } from '~hooks/queries/role/query';
import { useCompanyId } from '~hooks/useCompanyId';

import CommonModal from './CommonModal';

interface Props extends ModalProps {
  /**
   * 화면 | 기능
   */
  type: 'screen' | 'function';
  /**
   * 필요한 권한 (회사 권한 또는 자산 권한)
   */
  requiredPermission: PermissionRequirement[];
}

// 자산 권한 타입별 한국어 이름 매핑
const ASSET_PERMISSION_NAMES: Record<string, string> = {
  taxInvoicePermissions: '세금계산서',
  cashReceiptPermissions: '현금영수증',
  bankAccountPermissions: '은행계좌',
  corporateCardPermissions: '법인카드',
};

// 자산 권한 설명 생성 함수
function getAssetPermissionDescription(requirement: AssetPermissionRequirement): string {
  const assetName = ASSET_PERMISSION_NAMES[requirement.type] || requirement.type;
  return `${assetName}`;
}

const PermissionInfoModal = ({ requiredPermission, ...props }: Props) => {
  const { companyId } = useCompanyId();
  const router = useRouter();
  const { data: availablePermissionsData } = useAvailablePermissions(companyId);
  const availablePermissions = availablePermissionsData?.Data?.data?.companyPermissions;

  const onCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    props.onCancel?.(e);
    if (props.type === 'screen') {
      router.back();
    }
  };
  return (
    <CommonModal
      {...props}
      onCancel={onCancel}
      title={
        <Text textStyle="16_600">
          {`이 ${props.type === 'screen' ? '화면' : '기능'}에 접근할 수 있는 권한이 없어요.`}
        </Text>
      }
      footer={null}
    >
      <Flex direction="column">
        <Text textStyle="14_400">관리자에게 아래 권한을 문의해주세요.</Text>
        <ul style={{ paddingLeft: 18, listStyle: 'disc' }}>
          {requiredPermission.map((permission, index) => {
            // 문자열인 경우 기존 CompanyUserPermission 처리
            if (typeof permission === 'string') {
              const permissionItem = availablePermissions?.find(
                (item) => item.relationName === permission,
              );

              return (
                <li key={`company-${permission}`}>
                  <Text textStyle="14_400">{permissionItem?.description || permission}</Text>
                </li>
              );
            }

            // 객체인 경우 자산 권한 처리
            return (
              <li key={`asset-${permission.type}-${index}`}>
                <Text textStyle="14_400">{getAssetPermissionDescription(permission)}</Text>
              </li>
            );
          })}
        </ul>
        <Button
          style={{
            width: 'fit-content',
            alignSelf: 'flex-end',
            marginTop: 10,
          }}
          border
          buttonSize="large"
          onClick={onCancel}
        >
          닫기
        </Button>
      </Flex>
    </CommonModal>
  );
};

export default PermissionInfoModal;
export type { Props as PermissionInfoModalProps };
